import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "layout-content"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", null, "删除", -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_select = _resolveComponent("a-select");
  const _component_a_date_picker = _resolveComponent("a-date-picker");
  const _component_a_textarea = _resolveComponent("a-textarea");
  const _component_a_row = _resolveComponent("a-row");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_input_number = _resolveComponent("a-input-number");
  const _component_a_popconfirm = _resolveComponent("a-popconfirm");
  const _component_a_typography_text = _resolveComponent("a-typography-text");
  const _component_a_table_summary_cell = _resolveComponent("a-table-summary-cell");
  const _component_a_button = _resolveComponent("a-button");
  const _component_a_table_summary_row = _resolveComponent("a-table-summary-row");
  const _component_a_table = _resolveComponent("a-table");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: $setup.IsShow,
    "onUpdate:visible": _cache[35] || (_cache[35] = $event => $setup.IsShow = $event),
    confirmLoading: $setup.DMConfig.loading,
    title: $setup.DMConfig.Title,
    bodyStyle: {
      padding: '5px'
    },
    width: $setup.DMConfig.Width,
    "wrap-class-name": $setup.DMConfig.ModelClass,
    "ok-button-props": {
      disabled: $setup.IsDisabled
    },
    onOk: $setup.SubmitForm
  }, {
    default: _withCtx(() => [_createVNode(_component_a_spin, {
      spinning: $setup.DMConfig.loading,
      delay: 1000
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref: "RefForm",
        model: $setup.DMConfig.Model,
        "label-col": $setup.DMConfig.DMForm.form.labelCol
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, {
          size: "small"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "1",
            tab: "Information"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "billNo",
                  label: "单据编号"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.billNo,
                    "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.DMConfig.Model.billNo = $event),
                    disabled: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fCustNumber",
                  label: "客户代码",
                  rules: [{
                    required: true,
                    message: '请输入客户代码!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fCustNumber,
                    "onUpdate:value": _cache[1] || (_cache[1] = $event => $setup.DMConfig.Model.fCustNumber = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "po",
                  label: "PO#",
                  rules: [{
                    required: true,
                    message: 'PO# is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.po,
                    "onUpdate:value": _cache[2] || (_cache[2] = $event => $setup.DMConfig.Model.po = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "piNo",
                  label: "PI No",
                  rules: [{
                    required: true,
                    message: 'PI No is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.piNo,
                    "onUpdate:value": _cache[3] || (_cache[3] = $event => $setup.DMConfig.Model.piNo = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "productOriginLocation",
                  label: "Product Origin Location",
                  rules: [{
                    required: true,
                    message: 'Product Origin Location is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.productOriginLocation,
                    "onUpdate:value": _cache[4] || (_cache[4] = $event => $setup.DMConfig.Model.productOriginLocation = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "termsOfSale",
                  label: "Terms of Sale",
                  rules: [{
                    required: true,
                    message: 'Terms of Sale is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    value: $setup.DMConfig.Model.termsOfSale,
                    "onUpdate:value": _cache[5] || (_cache[5] = $event => $setup.DMConfig.Model.termsOfSale = $event),
                    options: $setup.DMConfig.TermsOfSaleList,
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "options"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "methodAndTermsOfPayment",
                  label: "Method and Terms of Payment",
                  rules: [{
                    required: true,
                    message: 'Method and Terms of Payment is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    value: $setup.DMConfig.Model.methodAndTermsOfPayment,
                    "onUpdate:value": _cache[6] || (_cache[6] = $event => $setup.DMConfig.Model.methodAndTermsOfPayment = $event),
                    options: $setup.DMConfig.SettleList,
                    style: {
                      "width": "100%"
                    }
                  }, null, 8, ["value", "options"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "finalDestination",
                  label: "Final Destination",
                  rules: [{
                    required: true,
                    message: 'Final Destination is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.finalDestination,
                    "onUpdate:value": _cache[7] || (_cache[7] = $event => $setup.DMConfig.Model.finalDestination = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "modeOfShipment",
                  label: "Mode of Shipment",
                  rules: [{
                    required: true,
                    message: 'Mode of Shipment is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.modeOfShipment,
                    "onUpdate:value": _cache[8] || (_cache[8] = $event => $setup.DMConfig.Model.modeOfShipment = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "portOfLoading",
                  label: "Port of Loading",
                  rules: [{
                    required: true,
                    message: 'Port of Loading is required'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.portOfLoading,
                    "onUpdate:value": _cache[9] || (_cache[9] = $event => $setup.DMConfig.Model.portOfLoading = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "shipmentDate",
                  label: "Shipment Date"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                    style: {
                      "width": "100%"
                    },
                    format: "YYYY-MM-DD",
                    value: $setup.DMConfig.Model.shipmentDate,
                    "onUpdate:value": _cache[10] || (_cache[10] = $event => $setup.DMConfig.Model.shipmentDate = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "comments",
                  label: "COMMENTS"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.comments,
                    "onUpdate:value": _cache[11] || (_cache[11] = $event => $setup.DMConfig.Model.comments = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 24,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "note",
                  label: "Remarks"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_textarea, {
                    value: $setup.DMConfig.Model.note,
                    "onUpdate:value": _cache[12] || (_cache[12] = $event => $setup.DMConfig.Model.note = $event),
                    placeholder: "If no product is found, please enter here",
                    "auto-size": {
                      minRows: 2,
                      maxRows: 5
                    },
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "2",
            tab: "Invoice to"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceTo",
                  label: "Customer (Invoice to)",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceTo,
                    "onUpdate:value": _cache[13] || (_cache[13] = $event => $setup.DMConfig.Model.customerInvoiceTo = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceTo1",
                  label: "Street",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceTo1,
                    "onUpdate:value": _cache[14] || (_cache[14] = $event => $setup.DMConfig.Model.customerInvoiceTo1 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceTo2",
                  label: "ZIP Codes",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceTo2,
                    "onUpdate:value": _cache[15] || (_cache[15] = $event => $setup.DMConfig.Model.customerInvoiceTo2 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceTo3",
                  label: "Country",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceTo3,
                    "onUpdate:value": _cache[16] || (_cache[16] = $event => $setup.DMConfig.Model.customerInvoiceTo3 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceToContact",
                  label: "Contact",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceToContact,
                    "onUpdate:value": _cache[17] || (_cache[17] = $event => $setup.DMConfig.Model.customerInvoiceToContact = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceToPhone",
                  label: "Phone"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceToPhone,
                    "onUpdate:value": _cache[18] || (_cache[18] = $event => $setup.DMConfig.Model.customerInvoiceToPhone = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceToFax",
                  label: "Fax"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceToFax,
                    "onUpdate:value": _cache[19] || (_cache[19] = $event => $setup.DMConfig.Model.customerInvoiceToFax = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "customerInvoiceToEmail",
                  label: "Email",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.customerInvoiceToEmail,
                    "onUpdate:value": _cache[20] || (_cache[20] = $event => $setup.DMConfig.Model.customerInvoiceToEmail = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "3",
            tab: "Deliver To"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "deliverTo",
                  label: "Deliver To"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.deliverTo,
                    "onUpdate:value": _cache[21] || (_cache[21] = $event => $setup.DMConfig.Model.deliverTo = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "deliverTo1",
                  label: "Address Line 1"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.deliverTo1,
                    "onUpdate:value": _cache[22] || (_cache[22] = $event => $setup.DMConfig.Model.deliverTo1 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "deliverTo2",
                  label: "Address Line 2"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.deliverTo2,
                    "onUpdate:value": _cache[23] || (_cache[23] = $event => $setup.DMConfig.Model.deliverTo2 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "deliverTo3",
                  label: "Country"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.deliverTo3,
                    "onUpdate:value": _cache[24] || (_cache[24] = $event => $setup.DMConfig.Model.deliverTo3 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "4",
            tab: "Notify Party"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 12,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "notifyParty",
                  label: "Notify Party"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.notifyParty,
                    "onUpdate:value": _cache[25] || (_cache[25] = $event => $setup.DMConfig.Model.notifyParty = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 12,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "notifyParty1",
                  label: "Address Line 1"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.notifyParty1,
                    "onUpdate:value": _cache[26] || (_cache[26] = $event => $setup.DMConfig.Model.notifyParty1 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 12,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "notifyParty2",
                  label: "Address Line 2"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.notifyParty2,
                    "onUpdate:value": _cache[27] || (_cache[27] = $event => $setup.DMConfig.Model.notifyParty2 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 12,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "notifyParty3",
                  label: "Contact (Phone/Email)"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.notifyParty3,
                    "onUpdate:value": _cache[28] || (_cache[28] = $event => $setup.DMConfig.Model.notifyParty3 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "5",
            tab: "Freight Forwarder"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              gutter: 24
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "freightForwarder",
                  label: "Freight Forwarder "
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.freightForwarder,
                    "onUpdate:value": _cache[29] || (_cache[29] = $event => $setup.DMConfig.Model.freightForwarder = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "freightForwarder1",
                  label: "Address Line 1"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.freightForwarder1,
                    "onUpdate:value": _cache[30] || (_cache[30] = $event => $setup.DMConfig.Model.freightForwarder1 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "freightForwarder2",
                  label: "Address Line 2"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.freightForwarder2,
                    "onUpdate:value": _cache[31] || (_cache[31] = $event => $setup.DMConfig.Model.freightForwarder2 = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "freightForwarderContact",
                  label: "Contact"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.freightForwarderContact,
                    "onUpdate:value": _cache[32] || (_cache[32] = $event => $setup.DMConfig.Model.freightForwarderContact = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 12,
                sm: 12
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "freightForwarderPhone",
                  label: "Phone"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.freightForwarderPhone,
                    "onUpdate:value": _cache[33] || (_cache[33] = $event => $setup.DMConfig.Model.freightForwarderPhone = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "9",
            tab: "Order Detail"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_table, {
              size: "small",
              tableLayout: _ctx.fixed,
              bordered: "",
              columns: $setup.DMConfig.Columns,
              dataSource: $setup.DMConfig.Model['items'],
              scroll: {
                x: 'calc(100%)'
              },
              pagination: false,
              rowKey: "FEntryId"
            }, {
              bodyCell: _withCtx(({
                column,
                record,
                index,
                text
              }) => [['customerProCode', 'descriptionOfGoods', 'color', 'electric'].includes(column.dataIndex) ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 0,
                name: ['items', index, column.dataIndex],
                rules: column.rules
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: record[column.dataIndex],
                  "onUpdate:value": $event => record[column.dataIndex] = $event,
                  allowClear: true
                }, null, 8, ["value", "onUpdate:value"])]),
                _: 2
              }, 1032, ["name", "rules"])) : column.dataIndex === 'productNumber' ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 1,
                name: ['items', index, column.dataIndex],
                rules: column.rules
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input, {
                  value: record[column.dataIndex],
                  "onUpdate:value": $event => record[column.dataIndex] = $event,
                  allowClear: true,
                  onChange: $event => $setup.OnSelectProductNumber(record)
                }, null, 8, ["value", "onUpdate:value", "onChange"])]),
                _: 2
              }, 1032, ["name", "rules"])) : column.dataIndex === 'qty' ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 2,
                name: ['items', index, column.dataIndex],
                rules: column.rules
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input_number, {
                  style: {
                    "width": "100%"
                  },
                  value: record[column.dataIndex],
                  "onUpdate:value": $event => record[column.dataIndex] = $event,
                  precision: 0,
                  onChange: $event => $setup.OnTotalAmt(record)
                }, null, 8, ["value", "onUpdate:value", "onChange"])]),
                _: 2
              }, 1032, ["name", "rules"])) : column.dataIndex === 'unitPrice' ? (_openBlock(), _createBlock(_component_a_form_item, {
                key: 3,
                name: ['items', index, column.dataIndex],
                rules: column.rules
              }, {
                default: _withCtx(() => [_createVNode(_component_a_input_number, {
                  style: {
                    "width": "100%"
                  },
                  value: record[column.dataIndex],
                  "onUpdate:value": $event => record[column.dataIndex] = $event,
                  precision: 2,
                  onChange: $event => $setup.OnTotalAmt(record)
                }, null, 8, ["value", "onUpdate:value", "onChange"])]),
                _: 2
              }, 1032, ["name", "rules"])) : column.dataIndex === 'operation' ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                key: 4,
                placement: "topRight",
                title: "确认删除？",
                onConfirm: () => $setup.delRow(record)
              }, {
                default: _withCtx(() => [_hoisted_2]),
                _: 2
              }, 1032, ["onConfirm"])) : _createCommentVNode("", true)]),
              summary: _withCtx(() => [_createVNode(_component_a_table_summary_row, null, {
                default: _withCtx(() => [_createVNode(_component_a_table_summary_cell, {
                  "col-span": 2
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_typography_text, {
                    strong: "true"
                  }, {
                    default: _withCtx(() => [_createTextVNode(" Processing Fee ")]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell, {
                  style: {
                    "text-align": "right"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_typography_text, {
                    strong: "true"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.DMConfig.Model.processingFee), 1)]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_a_table_summary_cell, {
                  style: {
                    "text-align": "right"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_button, {
                    size: "small",
                    onClick: $setup.addRow
                  }, {
                    default: _withCtx(() => [_createTextVNode("Add Row")]),
                    _: 1
                  }, 8, ["onClick"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_table_summary_row, null, {
                default: _withCtx(() => [_createVNode(_component_a_table_summary_cell, {
                  "col-span": 2
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_typography_text, {
                    strong: "true"
                  }, {
                    default: _withCtx(() => [_createTextVNode(" Discount ")]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell, {
                  style: {
                    "text-align": "right"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input_number, {
                    style: {
                      "width": "100%"
                    },
                    value: $setup.DMConfig.Model.discount,
                    "onUpdate:value": _cache[34] || (_cache[34] = $event => $setup.DMConfig.Model.discount = $event),
                    precision: 2,
                    onChange: $setup.OnChangeDiscount
                  }, null, 8, ["value", "onChange"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_table_summary_row, null, {
                default: _withCtx(() => [_createVNode(_component_a_table_summary_cell, {
                  "col-span": 2
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_typography_text, {
                    strong: "true"
                  }, {
                    default: _withCtx(() => [_createTextVNode(" TOTAL- ")]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell), _createVNode(_component_a_table_summary_cell, {
                  style: {
                    "text-align": "right"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_typography_text, {
                    strong: "true"
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString($setup.DMConfig.Model.total), 1)]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 8, ["tableLayout", "columns", "dataSource", "scroll"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "label-col"])])]),
      _: 1
    }, 8, ["spinning"])]),
    _: 1
  }, 8, ["visible", "confirmLoading", "title", "width", "wrap-class-name", "ok-button-props", "onOk"]);
}